import axios from "../../interceptors/axiosInterceptor";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import axiosInterceptorInstance from "interceptors/axiosInterceptor";
interface BazaarHttpClientConfigs {
    dispatchError?: boolean;
    normalizeError?: boolean;
}
const defaultConfigs: BazaarHttpClientConfigs = {
    dispatchError: true,
    normalizeError: true,
};

export class BazaarHttpClient {
  configs: BazaarHttpClientConfigs;
  constructor(configs: BazaarHttpClientConfigs = {}) {
      this.configs = { ...defaultConfigs, ...configs };
  }

  get = <T>(url: string, options?: Object): Promise<T> => {
    return new Promise((resolve, reject) => {
        let apiOptions = getAuthOptions();
        apiOptions = options ? { ...apiOptions, ...options } : apiOptions;
        axiosInterceptorInstance
            .get(url, apiOptions)
            .then((response) => {
                resolve(response ? response.data : null);
            })
            .catch((error) => {
                const errorPayload = this.configs.normalizeError
                    ? normalizeCatchErrors(error.response)
                    : error.response;
                //Global dispatch Error to ErrorReducer
                reject(errorPayload);
            });
    });
};

post = <T>(url: string, data: any, options?: Object): Promise<T> => {
  return new Promise((resolve, reject) => {
      let apiOptions = getAuthOptions();
      apiOptions = options ? { ...apiOptions, ...options } : apiOptions;
      axiosInterceptorInstance
          .post(url, data, apiOptions)
          .then((response) => {
              resolve(response ? response.data : null);
          })
          .catch((error) => {
              const errorPayload = this.configs.normalizeError
                  ? normalizeCatchErrors(error.response)
                  : error.response;
              reject(errorPayload);
          });
  });
};

put = <T>(url: string, data: any, options?: Object): Promise<T> => {
  return new Promise((resolve, reject) => {
      let apiOptions = getAuthOptions();
      apiOptions = options ? { ...apiOptions, ...options } : apiOptions;
      axiosInterceptorInstance
          .put(url, data, apiOptions)
          .then((response) => {
              resolve(response ? response.data : null);
          })
          .catch((error) => {
              const errorPayload = this.configs.normalizeError
                  ? normalizeCatchErrors(error.response)
                  : error.response;
              reject(errorPayload);
          });
  });
};

patch = <T>(url: string, data: any, options?: Object): Promise<T> => {
  return new Promise((resolve, reject) => {
      let apiOptions = getAuthOptions();
      apiOptions = options ? { ...apiOptions, ...options } : apiOptions;
      axiosInterceptorInstance
          .patch(url, data, apiOptions)
          .then((response) => {
              resolve(response ? response.data : null);
          })
          .catch((error) => {
              const errorPayload = this.configs.normalizeError
                  ? normalizeCatchErrors(error.response)
                  : error.response;
              reject(errorPayload);
          });
  });
};
}